<template>
  <div>
    <!-- ============================================================== -->
    <!-- Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <div class="page-breadcrumb border-bottom">
      <div class="row">
        <div class="col-md-4 col-xs-12 align-self-center">
          <h5 class="font-medium text-uppercase mb-0">
            Ads Campaign Management
          </h5>
        </div>
        <div class="col-md-8 col-xs-12 align-self-center">
          <button
            class="float-right ml-3 text-white btn btn-primary d-none d-md-block"
            @click="addAdsCampaign"
          >
            <i class="fas fa-plus"></i> Add Campaign
          </button>
          <nav aria-label="breadcrumb" class="mt-2 float-md-right float-left">
            <ol class="breadcrumb mb-0 justify-content-end p-0">
              <li class="breadcrumb-item">
                <a>Home</a>
              </li>
              <li aria-current="page" class="breadcrumb-item active">
                Ads Campaign
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </div>
    <!-- ============================================================== -->
    <!-- End Bread crumb and right sidebar toggle -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="page-content container-fluid">
      <!-- ============================================================== -->
      <!-- Start Page Content -->
      <!-- ============================================================== -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="form-group col-6">
                  <label for="slug">Search</label>
                  <div class="input-group">
                    <span class="input-group-btn">
                      <button
                        class="btn waves-effect waves-light btn-info"
                        type="button"
                      >
                        <i class="fa fa-search"></i>
                      </button>
                    </span>
                    <input
                      v-model="textSearch"
                      class="form-control"
                      placeholder="Search by any text fields"
                      type="text"
                      @change="searchCampaign()"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="table-responsive">
                  <div class="text-center">
                    <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
                  </div>
                  <table class="table">
                    <thead>
                      <tr>
                        <th 
                          v-for="header in headers" :key="header.value"
                          @click="sortByField(header.value)"
                        >
                          {{ header.text }}
                          <span v-if="sortBy === header.value">
                            <i
                              aria-hidden="true"
                              :class="{
                                'fas fa-sort-up': !sortDesc,
                                'fas fa-sort-down': sortDesc,
                              }"
                            ></i>
                          </span>
                        </th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in items"
                        :key="index"
                      >
                        <td>{{ item.id }}</td>
                        <td>{{ item.campaign }}</td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.start | dateTime }}</td>
                        <td>{{ item.end | dateTime }}</td>
                        <td>{{ item.source }}</td>
                        <td>{{ item.medium }}</td>
                        <td>{{ item.pic }}</td>
                        <td>{{ item.updatedAt | dateTime }}</td>
                        <td>{{ item.deletedAt | dateTime }}</td>
                        <td>
                          <b-badge href="#" variant="primary" class="mx-1" @click.stop="updateAdsCampaign(item)">
                            <i class="fas fa-edit"></i>
                          </b-badge>
                          <b-badge href="#" variant="danger" class="mx-1" @click.stop="deleteAdsCampaign(item)">
                            <i class="fas fa-trash-alt"></i>
                          </b-badge>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div v-if="!isLoading" class="overflow-auto">
                    <b-pagination
                      v-model="page"
                      :per-page="perPage"
                      :total-rows="total"
                    ></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <AdsCampaignForm
      v-if="isShowAdsCampaignForm"
      :type="campaignFormType"
      :adsCampaign="selectedAdsCampaign"
      @hide="hideAdsCampaignForm"
      @cancel="hideAdsCampaignForm"
      @refresh="getData"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import AdsCampaignAPI from "@/api/adsCampaign"
import AdsCampaignForm from './AdsCampaignForm.vue'

export default {
  name: "AdsCampaign",
  components: {
    AdsCampaignForm,
  },
  data() {
    return {
      items: [],
      page: 1,
      perPage: 30,
      total: 0,
      isLoading: false,
      sortDesc: true,
      sortBy: "id",
      textSearch: "",
      filters: {},
      isShowAdsCampaignForm: false,
      campaignFormType: "create",
      selectedAdsCampaign: {},
      headers: [
        { text: "ID", value: "id" },
        { text: "Campaign", value: "campaign" },
        { text: "Name", value: "name" },
        { text: "Start date", value: "start" },
        { text: "End date", value: "end" },
        { text: "Source", value: "source" },
        { text: "Medium", value: "medium" },
        { text: "Pic", value: "pic" },
        { text: "Updated at", value: "updatedAt" },
        { text: "Deleted at", value: "deletedAt" },
      ]
    }
  },
  created() {
    this.getData()
  },
  mounted() {},
  watch: {
    page: {
      handler: function () {
        this.getData()
      },
      deep: true,
    },
  },
  methods: {
    searchCampaign() {
      this.getData()
    },
    sortByField(field) {
      this.sortBy = field
      this.sortDesc = !this.sortDesc

      this.getData()
    },
    getFilterData() {
      const filters = {}

      Object.keys(this.filters).forEach((keyFilter) => {
        if (this.filters[keyFilter] !== "") {
          filters[keyFilter] = this.filters[keyFilter]
        }
      })
  
      return filters
    },
    async getData() {
      this.isLoading = true

      try {
        const params = this.buildParams()
        const res = await AdsCampaignAPI.listAdsCampaigns(params)

        if (res) {
          this.items = res.contents
          this.total = res.total
        }
      } finally {
        this.isLoading = false
      }
    },
    buildParams() {
      const params = {
        page: this.page,
        perPage: this.perPage,
        filters: this.getFilterData(),
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
      }

      if (this.textSearch) {
        params.textSearch = this.textSearch
      }

      return params
    },
    updateAdsCampaign(item) {
      this.campaignFormType = "update"
      this.selectedAdsCampaign = item
      this.isShowAdsCampaignForm = true
    },
    async confirmDeleteAdsCampaign(adsCampaign) {
      return this.$bvModal.msgBoxConfirm(
        `Are you sure to delete: ${adsCampaign.name}?`,
        { centered: true }
      )
    },
    async deleteAdsCampaign(adsCampaign) {
      const isConfirmed = await this.confirmDeleteAdsCampaign(adsCampaign)
      if (!isConfirmed) return

      await this.handleDeleteAdsCampaign(adsCampaign.id)
    },
    async handleDeleteAdsCampaign(id) {
      try {
        await AdsCampaignAPI.deleteAdsCampaign(id)

        this.$toasted.success("Delete ads campaign success!", { duration: 500 })

        if (this.items.length <= 1) {
          this.page--
        }

        this.getData()
      } catch (e) {
        console.log(e)
        this.$toasted.error("Delete ads campaign error!", { duration: 10000 })
      }
    },
    addAdsCampaign() {
      this.campaignFormType = "create"
      this.isShowAdsCampaignForm = true
    },
    hideAdsCampaignForm() {
      this.isShowAdsCampaignForm = false
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
